import i18n from 'i18next';
import { utils, writeFile } from 'xlsx';

import { QuestionType } from '~/data/surveys';

import {
  ServerChoiceData,
  ServerScaleData,
  ServerSurveyResults,
  ServerYesNoData,
  SurveyQuestion,
} from '../types';

export const exportSurveyResultsToExcel = (
  rawQuestions: SurveyQuestion[],
  resultsRawObj: ServerSurveyResults,
) => {
  const data = [[i18n.t('label_survey_question'), i18n.t('label_answer')]];

  resultsRawObj.results
    .slice()
    .sort(({ index: a }, { index: b }) => (a === b ? 0 : a > b ? 1 : -1))
    .forEach((result) => {
      const question = `${result.index}. ${result.questionText}`;

      switch (result.questionType) {
        case QuestionType.YES_NO: {
          const q = rawQuestions.find(({ id }) => id === result.questionId);
          const results = result.results as ServerYesNoData;

          data.push(
            [
              '',
              q && q.yesLabel ? q.yesLabel : 'Yes',
              q && q.noLabel ? q.noLabel : 'No',
            ],
            [question, results.yes.toString(), results.no.toString()],
            [],
          );

          break;
        }
        case QuestionType.SCALE: {
          const results = result.results as ServerScaleData;

          data.push(
            ['', '1', '2', '3', '4', '5'],
            [
              question,
              results[1].toString(),
              results[2].toString(),
              results[3].toString(),
              results[4].toString(),
              results[5].toString(),
            ],
            [],
          );

          break;
        }
        case QuestionType.SINGLE_CHOICE:
        case QuestionType.MULTIPLE_CHOICE: {
          const results = result.results as ServerChoiceData[];

          data.push(
            ['', ...results.map((r) => r.optionText)],
            [question, ...results.map((r) => r.count.toString())],
            [],
          );

          break;
        }
        case QuestionType.FREE_TEXT: {
          const results = result.results as string[];

          data.push(['', i18n.t('free_text')], [question, ...results], []);

          break;
        }
        default:
          break;
      }
    });

  const worksheet = utils.aoa_to_sheet(data);
  const workbook = utils.book_new();

  worksheet['!cols'] = [{ wpx: 200 }];

  utils.book_append_sheet(workbook, worksheet, i18n.t('label_results'));
  writeFile(
    workbook,
    `${resultsRawObj.name.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.xlsx`,
  );
};
